import {
  EmptyState,
  Button,
  PlusIcon,
  ClipboardListIcon,
} from '@buffer-mono/popcorn'

import { useHasOrganizationAction } from '~publish/contexts/AccountContext'

import type { JSX } from 'react'

export const SavedReplyEmptyState = ({
  setOpenForm,
}: {
  setOpenForm: (open: boolean) => void
}): JSX.Element => {
  const canManageSavedReplies = useHasOrganizationAction('manageSavedReplies')

  return (
    <EmptyState>
      <EmptyState.Icon>
        <ClipboardListIcon />
      </EmptyState.Icon>

      <EmptyState.Description>
        Save information you share often to quickly insert it to your replies
      </EmptyState.Description>
      {canManageSavedReplies && (
        <EmptyState.Actions>
          <Button variant="primary" onClick={(): void => setOpenForm(true)}>
            <PlusIcon />
            New Saved Reply
          </Button>
        </EmptyState.Actions>
      )}
    </EmptyState>
  )
}
